import { render, staticRenderFns } from "./MainModal.vue?vue&type=template&id=d00fb5ec&scoped=true"
import script from "./MainModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MainModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MainModal.vue?vue&type=style&index=0&id=d00fb5ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00fb5ec",
  null
  
)

export default component.exports